import { FC, useState } from "react";
import { Alert, Box, Button, Chip, Grid, IconButton, Paper, TextField, Tooltip, Typography } from "@mui/material";
import "./integration.css";
import { integration } from "../../arrays/integration";
import { useNavigate } from "react-router-dom";
import { CartColor } from "../../components/cartColor/CartColor";
import { CardInfo } from "../../components/common/cardInfo/CardInfo";
import userFetchProfile from "../../service/userProfile/userProfile";
import Snackbar from "../../components/notification/snackbar/snackbar";
import { AiOutlineLink, AiOutlineSave, AiOutlineSend } from "react-icons/ai";
import { useCreateUserConfigMutation } from "../../service/userUserConfig/createUserConfig";
import { useSendWebhookTestMutation } from "../../service/userUserConfig/createUserConfigSendTest";
import { CircularProgress } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import Message from "../../components/notification/message/message";

const Integration: FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth0();
  const storedToken = sessionStorage.getItem("userData");
  const { profile } = userFetchProfile(storedToken || "");
  const [copied, setCopied] = useState(false);

  const apiKey = profile?.data?.response?.data?.static_token || "Cargando...";
  const profileData = profile?.data?.response?.data;
  const [webhookUrl, setWebhookUrl] = useState("");
  const [createUserConfig, { isLoading: isSavingWebhook }] = useCreateUserConfigMutation();
  const [sendWebhookTest, { isLoading: isSendingTest }] = useSendWebhookTestMutation();
  const [webhookSaved, setWebhookSaved] = useState(false);
  const [webhookError, setWebhookError] = useState("");
  const [testSent, setTestSent] = useState(false);
  const [testError, setTestError] = useState("");

  const handleSaveWebhook = async () => {
    if (!webhookUrl.trim()) return;
    try {
      const now = new Date().toISOString();
      await createUserConfig({
        user: user?.sub || "",
        api: {
          webhook: webhookUrl,
        },
        email: profileData?.email || "",
        profileId: profileData?.id || profileData?._id || "",
        created_at: now,
        updated_at: now,
      }).unwrap();
      setWebhookSaved(true);
      setWebhookError("");
    } catch (err: any) {
      setWebhookError(err?.data?.message || "Error al guardar el webhook");
    }
  };

  const handleSendTest = async () => {
    try {
      await sendWebhookTest({
        user: user?.sub || "",
      }).unwrap();
      setTestSent(true);
      setTestError("");
    } catch (err: any) {
      setTestError(err?.data?.message || "Error al enviar la prueba");
    }
  };

  const handleCopyApiKey = () => {
    navigator.clipboard.writeText(apiKey);
    setCopied(true);
  };

  const handleCloseSnackbar = () => {
    setCopied(false);
  };

  return (

      <><Grid container spacing={4}>
      <Grid item xs={12}>
        <h2>Integraciones API</h2>
      </Grid>
      <Grid item xs={12}>
        <CardInfo message="Conecta tu aplicación o sistema a Pagos Fiable de manera rápida y segura mediante nuestra API." />
      </Grid>
    </Grid><Grid>
        <CartColor></CartColor>

      </Grid><Box className="integration-step">
        <Box className="step-header">
          <Box className="step-icon-container">
            {/* <KeyIcon className="step-icon" /> */}
          </Box>
          <Box className="step-content">
            <Typography variant="subtitle1" fontWeight="bold">
              Paso 1: Obtén tu Clave de API
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Tu clave de API es esencial para autenticar todas tus
              peticiones. Cópiala y guárdala en un lugar seguro.
            </Typography>
          </Box>
        </Box>

        <Box className="api-key-container">
          <Box className="api-key-input">
            <Typography
              variant="body2"
              className="api-key-text"
              sx={{ fontFamily: "monospace" }}
            >
              {apiKey}
            </Typography>
          </Box>
          <Tooltip title="Copiar clave">
            <IconButton
              onClick={handleCopyApiKey}
              className="copy-button"
              size="small"
            >
              {/* <ContentCopyIcon fontSize="small" /> */}
            </IconButton>
          </Tooltip>
        </Box>
      </Box><Box className="integration-step">
        <Box className="step-header">
          <Box className="step-icon-container step-icon-green">
            {/* <ExtensionIcon className="step-icon" /> */}
          </Box>
          <Box className="step-content">
            <Typography variant="subtitle1" fontWeight="bold">
              Paso 2: Conecta tu Aplicación
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Selecciona un conector oficial o integra directamente nuestra
              API en tu sistema.
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={3} className="integration-options">
          {integration?.map((item: any, index: number) => (
            <Grid item xs={6} sm={6} md={4} key={item.name}>
              <Paper
                elevation={0}
                className={`integration-option-card ${index === 1 ? "active" : ""}`}
                onClick={() => {
                  if (item.link === true) {
                    navigate(item.url);
                  } else {
                    window.open(
                      "https://www.pagosfiable.com/docs/",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }
                } }
              >
                {index === 1 && (
                  <Chip
                    label="ACTIVO"
                    size="small"
                    className="active-chip" />
                )}
                <Box className="option-icon-container">
                  <img
                    src={item.icon}
                    alt={item.name}
                    className="option-icon" />
                </Box>
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  className="option-title"
                >
                  {item.name}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  className="option-subtitle"
                >
                  {item.name === "WordPress"
                    ? "Plugin Oficial"
                    : "Integración directa"}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box className="integration-step">
        <Box className="step-header">
          <Box className="step-icon-container step-icon-orange">
            <AiOutlineLink className="step-icon" />
          </Box>
          <Box className="step-content">
            <Typography variant="subtitle1" fontWeight="bold">
              Paso 3: Configuración de Webhooks
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Ingresa la URL de tu servidor para recibir notificaciones en
              tiempo real sobre el estado de tus transacciones.
            </Typography>
          </Box>
        </Box>

        <Box className="webhook-input-container">
          <Box className="webhook-input-wrapper">
            <AiOutlineLink className="webhook-input-icon" />
            <input
              type="text"
              className="webhook-input"
              placeholder="https://tu-sitio.com/api/webhook"
              value={webhookUrl}
              onChange={(e) => setWebhookUrl(e.target.value)}
            />
          </Box>
        </Box>

        <Box className="webhook-buttons">
          <Button
            variant="contained"
            className="webhook-btn-save"
            startIcon={isSavingWebhook ? <CircularProgress size={18} color="inherit" /> : <AiOutlineSave />}
            onClick={handleSaveWebhook}
            disabled={isSavingWebhook || isSendingTest || !webhookUrl.trim()}
          >
            {isSavingWebhook ? "Guardando..." : "Guardar Configuración"}
          </Button>
          <Button
            variant="outlined"
            className="webhook-btn-test"
            startIcon={isSendingTest ? <CircularProgress size={18} /> : <AiOutlineSend />}
            onClick={handleSendTest}
            disabled={isSendingTest || isSavingWebhook}
          >
            {isSendingTest ? "Enviando..." : "Enviar Prueba"}
          </Button>
        </Box>
      </Box>

      <Message
        open={webhookSaved}
        message="Webhook guardado correctamente"
        severity="success"
        onClose={() => setWebhookSaved(false)}
      />
      <Message
        open={!!webhookError}
        message={webhookError}
        severity="error"
        onClose={() => setWebhookError("")}
      />
      <Message
        open={testSent}
        message="Prueba enviada correctamente"
        severity="success"
        onClose={() => setTestSent(false)}
      />
      <Message
        open={!!testError}
        message={testError}
        severity="error"
        onClose={() => setTestError("")}
      />

      </>
  );
};

export default Integration;
